// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"4482dee3","974":"c09c2726"}[chunkId] + ".chunk.js";
};